import { createAsyncThunk } from "@reduxjs/toolkit";
import { onboardingService } from "./OnboardingService";

export const submitRegistration = createAsyncThunk(
    "onboarding/submitRegistration",
    async (params: { 
        formData: any; 
        userId: string; 
    }) => {
        const response = await onboardingService.submitRegistration(params);
        return {
            data: response.data || null,
            status: response.status || false,
            message: response.message
        };
    }
);

export const fetchUserOnboardingList = createAsyncThunk(
    "onboarding/fetchUserOnboardingList",
    async (params: {
        filter?: string;
        limit?: number;
        offset?: number;
        properties?: string[];
        requestedInfo?: string;
        xFactory?: string;
        accountFilter?: { account_name?: string; status?: string };
    }) => {
        const {
            filter = "",
            limit = 30,
            offset = 0,
            properties = [],
            requestedInfo = "",
            xFactory = "dac",
            accountFilter
        } = params;

        const response = await onboardingService.fetchUserOnboardingList(
            filter,
            limit,
            offset,
            properties,
            requestedInfo,
            xFactory,
            accountFilter
        );

        return {
            data: response.data || [],
            status: response.status
        };
    }
);

export const addEditUser = createAsyncThunk(
    "onboarding/addEditUser",
    async (params: { userData: any; operation?: string; xFactory?: string }) => {
        const { userData, operation = "add", xFactory = "user" } = params;
        
        const response = await onboardingService.addEditUser(
            userData,
            operation,
            xFactory
        );

        return {
            data: response.data || null,
            status: response.status,
            message: response.message
        };
    }
);

export const submitAction = createAsyncThunk(
    "onboarding/submitAction",
    async (params: {
        accountData?: any;
        accountNumber?: string;
        sixStarNumber?: string;
        newStatus?: string;
        userName: string;
        userEmail: string;
        comments: string;
        action: 'feedback' | 'review' | 'complete';
        // ✅ Add params for user edit
        userId?: string;
        oneStarNumber?: string;
        threeStarNumber?: string;
        userRole?: any;
    }) => {
        const response = await onboardingService.submitAction(params);
        return {
            data: response.data || null,
            status: response.status || false,
            message: response.message
        };
    }
);